module.exports = __webpack_public_path__ + "static/media/video3-small.17a5ac65.png";